import { useState, useEffect, useRef } from 'react';
import axiosInstance from '../utils/axios';

// Cache to store scripts and avoid repeated API calls
const scriptCache = {
  data: null,
  timestamp: null,
  TTL: 5 * 60 * 1000, // 5 minutes cache TTL
};

export const useScripts = () => {
  const [scripts, setScripts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    // If already fetched in this component instance, don't fetch again
    if (hasFetched.current) return;

    const fetchScripts = async () => {
      // Check if cache exists and is still valid
      const now = Date.now();
      if (scriptCache.data && scriptCache.timestamp && (now - scriptCache.timestamp) < scriptCache.TTL) {
        setScripts(scriptCache.data);
        hasFetched.current = true;
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await axiosInstance.get('/script/list?pageSize=1000&page=1');
        const fetchedScripts = response.data.data?.docs || response.data.data || [];
        console.log('Fetched scripts from API:', response);
        // Update cache
        scriptCache.data = fetchedScripts;
        scriptCache.timestamp = Date.now();

        setScripts(fetchedScripts);
        hasFetched.current = true;
      } catch (err) {
        setError(err.message || 'Failed to fetch scripts');
        setScripts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchScripts();
  }, []);

  return { scripts, loading, error };
};
